<template>
	<div>
 		<v-menu
			absolute
			light
			offset-y
			max-height="400"
			transition="slide-y-transition"
			v-model="visible"
			:close-on-content-click="false"
			:position-y="y"
			:position-x="x"
		>
			<div class="intelissense-wrapper">
				<BaseInput
					ref="search"
					tabindex="1"
					type="text"
					v-model="search"
					@keyup.down="setItemActive({}, -1, 'down')"
					@keyup.esc="visible = false"
					@keyup.enter="sendItem({ item: filterItems[0], selectionStart })"
				>

				</BaseInput>
				<a
					class="item-link"
					v-for="(item, index) in filterItems"
					tabindex="2"
					:id="`item-link-${index}`"
					:key="item.id"
					@keyup.down="setItemActive(item, index, 'down')"
					@keyup.esc="visible = false"
					@keyup.enter="sendItem({ item, selectionStart })"
					@click.prevent="sendItem({ item, selectionStart })"
					@keyup.up="setItemActive(item, index, 'up')"
				>
					{{ item.code }} - {{ item.name }}
				</a>
			</div>
		</v-menu>
		<component
			autocomplete="off"
			class="body-1"
			hide-details
			v-bind="$attrs"
			v-on="$listeners"
			:is="tagName"
			@keyup.ctrl.space="openIntelissense"
		>
		</component>
	</div>
</template>

<script>

function data() {
	return {
		search: '',
		selectionStart: 0,
		visible: false,
		x: 0,
		y: 0,
	};
}

function filterItems() {
	return this.search
		? this.items.filter(i =>
			i.code.toLowerCase().includes(this.search) ||
			i.name.toLowerCase().includes(this.search),
		)
		: this.items;
}

function openIntelissense(e) {
	const rect = e.target.getBoundingClientRect();
	this.selectionStart = e.target.selectionStart;
	this.x = rect.x;
	this.y = rect.bottom;
	this.visible = true;
}

function sendItem({ item, selectionStart }) {
	if (item) {
		this.visible = false;
		this.search = '';
		this.$emit('click-item', { item, selectionStart });
	}
}

function setItemActive(item, index, direction) {
	const newIndex = direction === 'down' ? index + 1 : index - 1;
	if (newIndex > -1) {
		const currentItemDom = document.querySelector(`#item-link-${newIndex}`);
		if (currentItemDom) {
			currentItemDom.focus();
		}
	} else {
		this.$refs.search.focus();
	}
}

export default {
	name: 'app-intelissense',
	components: {
		BaseInput: () => import('@/components/shared/inputs/base-input'),
	},
	computed: {
		filterItems,
	},
	data,
	inheritAttrs: false,
	props: {
		tagName: {
			default: 'v-textarea',
			type: String,
		},
		items: {
			type: Array,
			default: () => [],
		},
	},
	methods: {
		openIntelissense,
		sendItem,
		setItemActive,
	},
	watch: {
		visible: {
			handler(newVal) {
				if (newVal) {
					setTimeout(() => {
						this.$refs.search.focus();
					}, 300);
				}
			},
		},
	},
};
</script>

<style scoped>
.intelissense-search {
	background-color: #fff;
	color: #000;
}

.intelissense-wrapper {
	background-color: #000;
	display: flex;
	flex-direction: column;
	padding: 20px;
}

.intelissense-wrapper > .item-link {
	border: 1px solid #fff;
	color: #fff;
	cursor: pointer;
	margin-bottom: 5px;
	padding: 5px;
	text-decoration: none;
}

.intelissense-wrapper > .item-link:focus {
	background-color: blue;
	font-weight: bolder;
}

.errorsw {
	color: red;
}
</style>


// WEBPACK FOOTER //
// src/components/shared/app-intelissense.vue